const fetchHTML = function (_options) {
    const defaults = {
        url: null,
        beforeSend: function () {},
        complete: function (_data) {},
        error: function (_err) {},
        debug: false,
    };
    const options = Object.assign({}, defaults, _options);

    if (options.beforeSend) options.beforeSend();

    fetch(options.url).then((response) => {
        return response
            .text()
            .then((html) => {
                if (options.debug) console.log(html);
                if (options.complete) options.complete(html);
            })
            .catch((err) => {
                if (options.error) options.error(err);
            });
    });
};

export default fetchHTML;
